var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavigationBar'),_c('div',{attrs:{"id":"app-body"}},[_c('router-view')],1),_c('br'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }